webpackJsonp([20],{

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(557)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(591),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['allergens'],
  data: function data() {
    return {
      language: this.$cookie.get('lang') || 'en',
      catalogAllergens: [],
      err: ''
    };
  },

  methods: {
    submitAllergens: function submitAllergens() {
      var allergens = [];
      this.catalogAllergens.forEach(function (allergen, index) {
        if (allergen.selected) {
          allergens.push(allergen.allergenId);
        }
      });
      this.$emit('submit', allergens);
    }
  },
  created: function created() {
    this.catalogAllergens = this.allergens.map(function (current) {
      var allergen = current;
      allergen.selected = false;
      return allergen;
    });
  }
});

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, ".checkbox-wrap{width:100%}.checkbox-wrap .input-group{min-width:140px;flex:none;width:auto;width:fit-content;padding:0 32px}.checkbox-wrap .input-group .input-group__details{display:none!important}.checkbox-wrap .input-group label{position:relative!important;left:0;max-width:220px;width:auto;width:fit-content;overflow:hidden}.checkbox-wrap .input-group .input-group__input{position:absolute;left:0;top:0;width:32px;flex:0}.checkbox-wrap .input-group \\--selection-controls{display:inline}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/MassAllergensAddModal.vue"],"names":[],"mappings":"AACA,eACE,UAAY,CACb,AACD,4BACI,gBAAiB,AACjB,UAAW,AACX,WAAY,AACZ,kBAAmB,AACnB,cAAgB,CACnB,AACD,kDACM,sBAAyB,CAC9B,AACD,kCACM,4BAA8B,AAC9B,OAAQ,AACR,gBAAiB,AACjB,WAAY,AACZ,kBAAmB,AACnB,eAAiB,CACtB,AACD,gDACM,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,MAAQ,CACb,AACD,kDACM,cAAgB,CACrB","file":"MassAllergensAddModal.vue","sourcesContent":["\n.checkbox-wrap {\n  width: 100%;\n}\n.checkbox-wrap .input-group {\n    min-width: 140px;\n    flex: none;\n    width: auto;\n    width: fit-content;\n    padding: 0 32px;\n}\n.checkbox-wrap .input-group .input-group__details {\n      display: none !important;\n}\n.checkbox-wrap .input-group label {\n      position: relative !important;\n      left: 0;\n      max-width: 220px;\n      width: auto;\n      width: fit-content;\n      overflow: hidden;\n}\n.checkbox-wrap .input-group .input-group__input {\n      position: absolute;\n      left: 0;\n      top: 0;\n      width: 32px;\n      flex: 0;\n}\n.checkbox-wrap .input-group --selection-controls {\n      display: inline;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(531);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("22e3573e", content, true, {});

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('h2', [_vm._v("Mass add Allergens")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-layout', {
    staticClass: "checkbox-wrap my-4",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, _vm._l((_vm.catalogAllergens), function(allergen, index) {
    return _c('v-checkbox', {
      key: index,
      attrs: {
        "color": "primary",
        "label": allergen.name[_vm.language]
      },
      on: {
        "change": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (allergen.selected),
        callback: function($$v) {
          _vm.$set(allergen, "selected", $$v)
        },
        expression: "allergen.selected"
      }
    })
  }), 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitAllergens()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/20.ca1330d7bd982a799797.js